// Import your modules
import './module/donotchange';
import './module/slider';
import './module/gallery';
import './module/menu';
import './module/banner';
